import { Module } from 'vuex';
import { RootState } from '@/store/types';
import { WaitingState } from '@/store/waitings/types';
import mutations from './mutations';
import actions from './actions';

const Waitings: Module<WaitingState, RootState> = {
  state: {
    waitings: [],
  },
  mutations,
  actions,
};

export default Waitings;
